import React from 'react';
import { useTranslation } from 'react-i18next';
import AbilityScoreTile from './AbilityScoreTile';

const TestResultsWidget = ({ abilityScores, showHeading = true, className = '' }) => {
    const { t } = useTranslation();
    if (!abilityScores?.length) return null;
    return (
        <div className={`mb-6 ${className}`.trim()}>
            {showHeading ? (
                <h3 className="text-lg font-medium text-ink mb-3">{t('userDashboard.abilityScores')}</h3>
            ) : null}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {abilityScores.map(({ slug, value, i18nKey }) => (
                    <AbilityScoreTile
                        key={slug}
                        slug={slug}
                        value={value}
                        label={t(i18nKey)}
                    />
                ))}
            </div>
        </div>
    );
};

export default TestResultsWidget;
